import { jsx as _jsx } from "react/jsx-runtime";
import { MantineProvider } from "@mantine/core";
import { NotificationsProvider } from "@mantine/notifications";
import { tokens } from "@releaseit/design-system";
var THEME = {
    primaryColor: "green",
    colors: {
        green: [
            "#E0FFEA",
            "#BBFFD1",
            "#95FFB7",
            "#19FF70",
            "#00FF53",
            "#00FF51",
            "#00FF32",
            "#00F12C",
            "#00D226",
            "#00B721", 
        ]
    },
    breakpoints: tokens.BREAKPOINTS,
    fontFamily: tokens.FONTS.sans,
    // fontSizes: tokens.FONT_SIZES,
    shadows: tokens.SHADOWS,
    radius: {
        sm: Number(tokens.RADII.sm.replace("px", "")),
        md: Number(tokens.RADII.md.replace("px", "")),
        lg: Number(tokens.RADII.lg.replace("px", ""))
    }
};
export function UIProvider(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(MantineProvider, {
        theme: THEME,
        children: /*#__PURE__*/ _jsx(NotificationsProvider, {
            position: "top-right",
            autoClose: 10000,
            children: children
        })
    });
}
